import React, { useContext, useEffect } from "react";
//import { findAllByDisplayValue } from "@testing-library/react";
import LocationContext from "geospatial/contextLocation";

const Location = (props) => {
  const { locationState, locationDispatch } = useContext(LocationContext);

  useEffect(() => {
    navigator.permissions &&
      navigator.permissions.query({ name: "geolocation" }).then((res) => {
        res.onchange = (e) => {
          // detecting if the event is a change
          if (e.type === "change") {
            // checking what the new permissionStatus state is
            const newState = e.target.state;
            if (newState === "denied") {
              console.log("why did you decide to block us?");
              locationDispatch({
                type: "SET_USE_LOCATION",
                values: {
                  useLocation: "false",
                },
              });
            } else if (newState === "granted") {
              console.log("We will be together forever!");
              locationDispatch({
                type: "SET_USE_LOCATION",
                values: {
                  useLocation: "true",
                },
              });
            } else {
              console.log("Thanks for reverting things back to normal");
              locationDispatch({
                type: "SET_USE_LOCATION",
                values: {
                  useLocation: "true",
                },
              });
            }
          }
        };
      });

    return () => {};
  }, [locationDispatch]);

  useEffect(() => {
    const storePosition = (position) => {
      position === undefined
        ? locationDispatch({
            type: "SET_LOCATION",
            values: {
              latitude: 0,
              longitude: 0,
              accuracy: 21000000,
            },
          })
        : locationDispatch({
            type: "SET_LOCATION",
            values: {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              accuracy: position.coords.accuracy,
            },
          });
    };

    const setLocation = () => {
      if (navigator.geolocation && locationState.useLocation === "true") {
        navigator.permissions &&
          navigator.permissions.query({ name: "geolocation" }).then((r) => {
            r.state === "denied" &&
              alert(
                "Don't forget to grant browser permission to allow world.reaches.me to use location..."
              );
          });
        navigator.geolocation.getCurrentPosition(storePosition);
      } else {
        console.log(
          "Geolocation blocked by user or not supported by this browser."
        );
        storePosition(undefined);
      }
    };
    setLocation();
    let interval = setInterval(() => {
      setLocation();
    }, props.poll_interval);

    return () => {
      clearInterval(interval);
    };
  }, [
    locationDispatch,
    locationState.useLocation,
    props.locate_interval,
    props.poll_interval,
  ]);

  let content = <div></div>;
  return content;
};

export default React.memo(Location, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
